export const RECIPIENT_TYPE = {
	TO: "TO",
	CC: "CC",
	BCC: "BCC",
} as const;

export type RecipientType =
	(typeof RECIPIENT_TYPE)[keyof typeof RECIPIENT_TYPE];

export const RECIPIENT_TYPE_COLOR: Record<RecipientType, string> = {
	TO: "#2e7d32",
	CC: "#0288d1",
	BCC: "#7b1fa2",
};

export interface EmailAddressTopic {
	EmailTopicId: number;
	EmailAddressId: number;
	Address: string;
	RecipientType: RecipientType;
	IsActive: boolean;
}
